import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Person } from '../../models/person.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BusinessServiceType } from '../../../shared/enums/business-service-type';
import { ServicePermission } from '../../models/service-permissions.model';

@Component({
  selector: 'app-auction-permission',
  templateUrl: './auction-permission.component.html',
  styleUrl: './auction-permission.component.scss',
  standalone: false
})
export class AuctionPermissionComponent implements OnInit{
  private formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
  @Input() person: Person;
  @Output() updatedPermission = new EventEmitter<ServicePermission>();
  auctionsForm: UntypedFormGroup;
  hasAllowChanged: boolean;

  get auctionServicePermission(): ServicePermission {
    return this.person?.servicePermissions.find(x => x.serviceType === BusinessServiceType.Auction);
  }

  ngOnInit(){
    this.auctionsForm = this.formBuilder.group({
      allowed: this.formBuilder.control(this.auctionServicePermission?.allowed),
    });
  }

  onChange($event: { checked: boolean; }) {
    this.hasAllowChanged = $event.checked !== this.auctionServicePermission.allowed;
  }

  onSubmit() {
    this.updatedPermission.emit({
        serviceType: BusinessServiceType.Auction,
        allowed: this.auctionsForm.controls.allowed.value
      });

    this.auctionsForm.markAsPristine();
  }
}
